import About from "../sections/About";
import Hero from "../sections/Hero";
import Showcase from "../sections/Showcase";
import Testimony from "../sections/Testimony";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Showcase />
      <Testimony />
      <About />
    </>
  );
}
